import { createContext } from 'react';

const PortfolioIsReadOnlyContext = createContext<boolean>(false);

export default PortfolioIsReadOnlyContext;
